export enum SupportedType {
    GiftCard = 'Gift Card',
    EGiftCard = 'eGift Card',
    Reloadable = 'Reloadable',
    DigitalReloadable = 'Digital Reloadable',
}

export const supportedTypeDisplayLabel: Record<string, string> = {
    [SupportedType.EGiftCard]: 'eGift',
    [SupportedType.DigitalReloadable]: 'eGift (Reloadable)',
};

// RaiseRight Future State label set for the "Gift Card Type" filter, adopted by web first
// (ENG-95) and available for native (ENG-96). Facet values without a mapping, such as the
// lower-environment-only `Physical Reload`, fall back to the raw value.
export const physicalSupportedTypeDisplayLabel: Record<string, string> = {
    ...supportedTypeDisplayLabel,
    [SupportedType.GiftCard]: 'Physical',
    [SupportedType.Reloadable]: 'Physical (Reloadable)',
};
